import { Route, Routes } from 'react-router-dom';
// layouts
import { MainLayout } from '../layouts/MainLayout';
// pages
import { Home } from '../pages/Home';
import { Login } from '../pages/Login';
import { JobControl } from '../pages/JobControl/JobControl';
import { LiveTrack } from '../pages/LiveTrack';
import { SiteMap } from '../pages/SiteMap';
import { SiteMapWPig } from '../pages/SiteMapWPig';
import { LiveTrackEdit } from '../pages/LiveTrackEdit';
import { ClientDashboard } from '../pages/ClientDashboard';
import { AdminDashboard } from "../pages/admin/AdminDashboard";
import { SignUp } from '../pages/SignUp';
import { ResetPassword } from '../pages/ResetPassword';
import { Unauthorized } from '../pages/Unauthorized';
import { ChangePassword } from '../pages/ChangePassword';
import { ApproveSpeed } from '../pages/ApproveSpeed';
import { ProtectedRoute } from "../components/routes/ProtectedRoute";
import { Poi } from '../pages/Poi';
import { SpeedNotificationApprovals } from "../pages/SpeedNotificationApprovals"
// contexts
import { UserProvider } from '../contexts/UserContext';


export const MarTrakRoutes = () => {

    //list of protected routes
    const protectedRoutes = [
        { path: 'job-control', element: <JobControl />, permission: { resource: 'jobs', action: 'read' } },
        { path: 'live-track', element: <LiveTrack />, permission: { resource: 'livetracks', action: 'read' } },
        { path: 'live-track-edit', element: <LiveTrackEdit />, permission: { resource: 'livetracks', action: 'update' } },
        { path: 'poi-edit', element: <Poi />, permission: { resource: 'pois', action: 'update' } },
        { path: 'site-map', element: <SiteMap />, permission: { resource: 'sitemaps', action: 'read' } },
        { path: 'site-map-pig', element: <SiteMapWPig />, permission: { resource: 'sitemaps', action: 'read' } },
        { path: 'admin-dashboard', element: <AdminDashboard />, groups: ['Admin'] },
        { path: 'speed-approvals', element: <SpeedNotificationApprovals />, groups: ['Admin', 'Supervisor', 'Project Manager', 'Tracker']},
        { path: 'client', element: <ClientDashboard /> },
        { path: 'change-password', element: <ChangePassword /> },
        { path: 'unauthorized', element: <Unauthorized /> },
    ];

    return (
        <UserProvider>
            <Routes>
                <Route path="/" element={<MainLayout />}>

                    {/* routes that are accessible without being authenticated */}
                    <Route path="login" element={<Login />} />
                    <Route path="accessjob" element={<Login />} />
                    <Route path="signup" element={<SignUp />} />
                    <Route path="signup/accessjob" element={<SignUp />} />
                    <Route path="resetPassword" element={<ResetPassword />} />
                    <Route path="speed" element={<ApproveSpeed />} />

                    {/* in protected route component, map over protected routes */}
                    <Route element={<ProtectedRoute />}>
                        <Route index element={<Home />} />
                        {protectedRoutes.map(({ path, element, permission, groups }) => (
                            <Route
                                key={path}
                                path={path}
                                element={<ProtectedRoute requiredPermission={permission} requiredGroups={groups}>{element}</ProtectedRoute>}
                            />
                        ))}
                    </Route>
                </Route>
            </Routes>
        </UserProvider>
    );
};